export default __webpack_public_path__ + "static/BouncingArrow-84c456f8d69d9e223f90f2f32de90220.gif";